import VisibilityIcon from "@mui/icons-material/Visibility";
import { ButtonBase, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

const REVEAL_MS = 30 * 1000;

// Masked until tapped, then shown for a short while.
export default function PasswordValue({ value }: { value: string | null }) {
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    if (!revealed) return;
    const timer = window.setTimeout(() => setRevealed(false), REVEAL_MS);
    return () => window.clearTimeout(timer);
  }, [revealed]);

  if (!value) {
    return (
      <Typography variant="body2" color="text.secondary">
        <FormattedMessage defaultMessage="(none)" />
      </Typography>
    );
  }

  return (
    <ButtonBase
      onClick={() => setRevealed((r) => !r)}
      sx={{ gap: 0.75, py: 0.5, borderRadius: 1, justifyContent: "flex-start" }}
    >
      <Typography variant="body2" sx={{ fontFamily: "monospace", fontWeight: 600 }}>
        {revealed ? value : "••••••"}
      </Typography>
      {!revealed && <VisibilityIcon fontSize="small" color="action" />}
    </ButtonBase>
  );
}
